import { Box, Typography } from "@mui/material";
import type { BackNavigationConfig } from "Navigation/types";
import { useGoBack } from "Navigation/useGoBack";
import type { ReactNode } from "react";
import styled from "styled-components";

type Props = {
  title?: string;
  onChevronClick?: () => void;
  children?: ReactNode;
  backNavigation?: BackNavigationConfig;
  isSmall?: boolean;
};

const ChevronWrapper = styled.div<{ $isSmall?: boolean }>`
  display: flex;
  cursor: pointer;
  margin-right: ${(props) => props.theme.spacing(2)};

  svg {
    height: ${({ $isSmall }) => ($isSmall ? "1.1em" : "1.4em")};
    width: ${({ $isSmall }) => ($isSmall ? "1.1em" : "1.4em")};
    color: ${({ theme }) => theme.palette.primary.dark};
  }
`;

export const PageTitle = ({
  title,
  children,
  onChevronClick,
  backNavigation = { mode: "disabled" },
  isSmall = false,
}: Props) => {
  const { navigateBack, canNavigateBack } = useGoBack(backNavigation);

  return (
    <Box
      display="flex"
      justifyItems="flex-start"
      alignItems={children ? "center" : "baseline"}
      className={canNavigateBack ? "go-back-url" : "no-go-back-url"}
    >
      {(canNavigateBack || onChevronClick) && (
        <ChevronWrapper
          className="chevron-wrapper"
          onClick={onChevronClick || navigateBack}
          $isSmall={isSmall}
        >
          <svg
            className="MuiSvgIcon-root MuiSvgIcon-fontSizeLarge css-tzssek-MuiSvgIcon-root"
            viewBox="8 6 7.41 12"
          >
            <path d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
          </svg>
        </ChevronWrapper>
      )}
      {!!title && (
        <Typography
          variant="h3"
          fontSize={isSmall ? 20 : undefined}
          component="h1"
        >
          {title}
        </Typography>
      )}
      {children}
    </Box>
  );
};
